import {
  FONT,
  GAEA_COLOURS,
  SPACING,
  mediaMinWidth,
  styled,
  UNIT,
} from "@dexibit/styles";

const BANNER_HEIGHT = 28;
const MARQUEE_GAP = 120;

const SEVERITY_COLOURS = {
  warning: {
    background: GAEA_COLOURS.UTILITY.AMBER.AMBER_LIGHTER,
    text: GAEA_COLOURS.UTILITY.AMBER.AMBER_DARKEST,
  },
  critical: {
    background: GAEA_COLOURS.UTILITY.RED.RED_LIGHTER,
    text: GAEA_COLOURS.UTILITY.RED.RED_DARKEST,
  },
} as const;

export type BannerSeverity = keyof typeof SEVERITY_COLOURS;

export { BANNER_HEIGHT };

export const BannerWrapper = styled("div")<{ $severity: BannerSeverity }>`
  width: 100%;
  box-sizing: border-box;
  font-size: ${FONT.BODY_REGULAR.fontSize};
  font-family: ${FONT.BODY_SMALL.fontFamily};
  background-color: ${(props) => SEVERITY_COLOURS[props.$severity].background};
  color: ${(props) => SEVERITY_COLOURS[props.$severity].text};
  overflow: hidden;
  height: ${BANNER_HEIGHT}px;

  ${mediaMinWidth.tablet(`
    transition: background-color 0.4s ease-in-out, color 0.4s ease-in-out;
  `)}
`;

export const VerticalCycler = styled("div")<{ $offset: number; $animate: boolean }>`
  display: none;
  flex-direction: column;
  transition: ${(props) => (props.$animate ? "transform 0.4s ease-in-out" : "none")};
  transform: translateY(${(props) => props.$offset * -BANNER_HEIGHT}px);

  ${mediaMinWidth.tablet(`
    display: flex;
  `)}
`;

export const VerticalItem = styled("div")`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${UNIT.small};
  height: ${BANNER_HEIGHT}px;
  padding: 0 ${UNIT.small};
  flex-shrink: 0;
  white-space: nowrap;
  overflow: hidden;
`;

export const MarqueeContainer = styled("div")<{ $severity: BannerSeverity }>`
  display: flex;
  align-items: center;
  height: ${BANNER_HEIGHT}px;
  background-color: ${(props) => SEVERITY_COLOURS[props.$severity].background};
  color: ${(props) => SEVERITY_COLOURS[props.$severity].text};

  ${mediaMinWidth.tablet(`
    display: none;
  `)}
`;

export const MarqueeTrack = styled("div")<{ $count: number; $durationPerItem: number }>`
  display: flex;
  align-items: center;
  white-space: nowrap;

  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-50%);
    }
  }

  animation: marquee ${(props) => props.$count * props.$durationPerItem}s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

export const MarqueeItem = styled("span")`
  display: inline-flex;
  align-items: center;
  gap: ${UNIT.small};
  flex-shrink: 0;
  padding-right: ${MARQUEE_GAP}px;
`;

export const LearnMoreButton = styled("button")`
  background: none;
  border: none;
  padding: 0;
  margin-left: ${UNIT.small};
  font-size: inherit;
  font-family: inherit;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
`;

export const PopoverContent = styled("div")`
  padding: ${SPACING.regular};
  max-width: 360px;
  font-size: ${FONT.BODY_REGULAR.fontSize};
  font-family: ${FONT.BODY_REGULAR.fontFamily};
  line-height: 1.5;
`;
